import React, { useState, useEffect } from "react";
import { db, storage } from "../../../../../firebase";
import { collection, doc, setDoc, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { query, where } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const AddProjects = () => {
  const [formData, setFormData] = useState({
    projectInfo: {},
    locationInfo: {},
    floorPlans: {},
    companyInfo: "",
    buildingFeatures: {},
    outsideFeatures: {},
    environmentFeatures: {}
  });

  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCities, setLoadingCities] = useState(true);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingCompanies, setLoadingCompanies] = useState(true);
  const [currentCompany, setCurrentCompany] = useState("");
  const [currentCompanyName, setCurrentCompanyName] = useState("");
  const navigate = useNavigate();

  // Feature lists
  const buildingFeaturesList = [
    'Merkezi ısıtma sistemi',
    'Doğalgaz altyapısı',
    'Yerden ısıtma sistemi',
    'Isı yalıtımı',
    'Ses yalıtımı',
    'Klima altyapısı',
    'Merkezi klima (VRF sistemi)',
    'Kombi sistemi',
    'Asansör',
    'Yük asansörü',
    'Akıllı ev sistemi',
    'Güvenlik sistemi',
    'Yangın alarmı',
    'Yangın merdiveni',
    'Sprinkler yangın söndürme sistemi',
    'Jeneratör',
    'UPS sistemi',
    'Fiber internet altyapısı',
    'Uydu/TV altyapısı',
    'Görüntülü diafon',
    'Güneş enerjisi sistemi',
    'Engelli erişimi',
    'Radye temel',
    'Tünel kalıp sistemi',
    'Sismik izolatörlü yapı',
    'Özel güvenlik kapısı',
    'Temizlik hizmetleri',
    'Ortak depo / kiler alanı',
    'Kiler (daireye özel)',
    'Balkon',
    'Akıllı sayaçlar',
    'Site yönetimi hizmeti'
  ];

  const outsideFeaturesList = [
    'Ortak kullanım bahçesi',
    'Çocuk oyun alanı',
    'Spor alanı',
    'Basketbol sahası',
    'Voleybol sahası',
    'Tenis kortu',
    'Fitness alanı',
    'Yürüyüş parkuru',
    'Bisiklet park yeri',
    'Kamelya / oturma alanı',
    'Açık yüzme havuzu',
    'Kapalı yüzme havuzu',
    'Sauna',
    'Hamam',
    'Buhar odası',
    'Masaj odası',
    'Açık otopark',
    'Kapalı otopark',
    'Misafir otoparkı',
    'Otoparkta elektrikli araç şarj ünitesi',
    '7/24 güvenlik',
    'Güvenlik kamerası sistemi (CCTV)',
    'Kartlı giriş sistemi',
    'Plaka tanıma sistemi',
    'Turnike giriş sistemi',
    'Acil durum çıkışları',
    'Site içi ATM',
    'Site içi market',
    'Evcil hayvan alanı',
    'Evcil hayvan parkuru'
  ];

  const environmentFeaturesList = [
    'Market',
    'Alışveriş merkezi (AVM)',
    'İlkokul',
    'Lise',
    'Anaokulu / kreş',
    'Üniversite',
    'Park alanı',
    'Oyun parkı',
    'Metro / tramvay durağı',
    'Otobüs durağı',
    'Minibüs güzergahı',
    'Otogar',
    'tren istasyonu',
    'havaalanı',
    'Hastane',
    'Sağlık ocağı',
    'Aile sağlık merkezi',
    'Eczane',
    'Camii',
    'Kilise',
    'İlçe Belediye Binası',
    'İl Belediye Binası',
    'Polis karakolu',
    'Postane Şubeleri',
    'Sosyal tesis / kültür merkezi',
    'Spor salonları',
    'Açık hava spor alanları',
    'Kafeterya / restoran / kafe',
    'Sinema / tiyatro',
    'Sahil / deniz manzarası',
    'Orman / doğa manzarası',
    'Göl / nehir manzarası',
    'Sessiz ve sakin çevre',
    'Gelişen bölge / yatırım potansiyeli',
    'Ana caddeye yakınlık',
    'Sanayiye yakınlık',
    'iş merkezlerine yakınlık',
    'Kütüphane',
    'Halk eğitim merkezi'
  ];

  // Fetch cities, companies and current company on component mount
  useEffect(() => {
    const fetchData = async () => {
      // 🔄 Güncellendi: Dashboard ile aynı şekilde şirket bilgisi çek
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        const storedData = localStorage.getItem("companyData");

        if (!user || !storedData) {
          navigate("/login_corporate");
          return;
        }

        const parsedData = JSON.parse(storedData);
        const email = parsedData?.email;
        const taxNumber = parsedData?.taxNumber;
        
        if (!email || !taxNumber) {
          navigate("/login_corporate");
          return;
        }

        // 🔄 Şirketi vergi numarasına göre çek
        const companiesRef = collection(db, 'companies');
        const q = query(companiesRef, where("taxInfo.taxNumber", "==", Number(taxNumber)));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const companyDoc = querySnapshot.docs[0];
          const companyData = companyDoc.data();
          setCurrentCompany(companyDoc.id);
          setCurrentCompanyName(companyData.company_name || companyDoc.id);
          setFormData(prev => ({ ...prev, companyInfo: companyDoc.id }));
        }
      } catch (error) {
        console.error('Mevcut şirket bilgisi çekilirken hata:', error);
      }

      // Fetch cities
      try {
        const querySnapshot = await getDocs(collection(db, 'cities'));
        const cityList = querySnapshot.docs.map(doc => doc.id);
        setCities(cityList.sort());
        setLoadingCities(false);
      } catch (error) {
        console.error('Şehirleri çekerken hata:', error);
      }

      // Fetch companies (sadece liste için)
      try {
        const querySnapshot = await getDocs(collection(db, 'companies'));
        const companyList = querySnapshot.docs.map(doc => doc.id);
        setCompanies(companyList.sort());
        setLoadingCompanies(false);
      } catch (error) {
        console.error('Şirketleri çekerken hata:', error);
      }
    };

    fetchData();
  }, [navigate]);

  // Fetch districts when city is selected
  const fetchDistricts = async (cityId) => {
    setLoadingDistricts(true);
    try {
      const districtsRef = collection(db, 'cities', cityId, 'districts');
      const districtSnapshot = await getDocs(districtsRef);
      const districtList = districtSnapshot.docs.map(doc => doc.id);
      setDistricts(districtList.sort());
      setLoadingDistricts(false);
    } catch (error) {
      console.error('İlçeleri çekerken hata:', error);
    }
  };

  const handleProjectInfoChange = (data) => {
    setFormData((prev) => ({ ...prev, projectInfo: data }));
  };

  const handleLocationInfoChange = (data) => {
    setFormData((prev) => ({ ...prev, locationInfo: data }));
  };

  const handleFloorPlansChange = (data) => {
    setFormData((prev) => ({ ...prev, floorPlans: data }));
  };

  const handleCompanyInfoChange = (data) => {
    setFormData((prev) => ({ ...prev, companyInfo: data }));
  };

  const handleBuildingFeaturesChange = (data) => {
    setFormData((prev) => ({ ...prev, buildingFeatures: data }));
  };

  const handleOutsideFeaturesChange = (data) => {
    setFormData((prev) => ({ ...prev, outsideFeatures: data }));
  };

  const handleEnvironmentFeaturesChange = (data) => {
    setFormData((prev) => ({ ...prev, environmentFeatures: data }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Get the next project ID
      const projectsRef = collection(db, "projects");
      const projectsSnapshot = await getDocs(projectsRef);
      const nextId = projectsSnapshot.size + 1;

      // Upload brochure if exists
      let brochureUrl = "";
      if (formData.projectInfo.brochure) {
        const brochureRef = ref(storage, `projects/${nextId}/brochure.pdf`);
        await uploadBytes(brochureRef, formData.projectInfo.brochure);
        brochureUrl = await getDownloadURL(brochureRef);
      }

      // Upload project images (only .png, .jpg, .jpeg)
      const imageUrls = [];
      if (formData.projectInfo.images && formData.projectInfo.images.length > 0) {
        for (let i = 0; i < formData.projectInfo.images.length; i++) {
          const image = formData.projectInfo.images[i];
          const fileExtension = image.name.split('.').pop().toLowerCase();
          if (['png', 'jpg', 'jpeg'].includes(fileExtension)) {
            const imageRef = ref(storage, `projects/${nextId}/image/${i}.${fileExtension}`);
            await uploadBytes(imageRef, image);
            const url = await getDownloadURL(imageRef);
            imageUrls.push(url);
          }
        }
      }

      // Create main project document
      const projectData = {
        project_name: formData.projectInfo.projectName,
        price: formData.projectInfo.price,
        city: formData.projectInfo.city,
        district: formData.projectInfo.district,
        delivery_date: formData.projectInfo.deliveryDate,
        num_houses: parseInt(formData.projectInfo.totalUnits) || 0,
        area: formData.projectInfo.area || "",
        project_status: parseInt(formData.projectInfo.projectStatus) || 0,
        project_description: formData.projectInfo.description,
        arch_description: formData.floorPlans.description || "",
        pdf_brochure: brochureUrl,
        image_urls: imageUrls,
        company_ref: doc(db, `companies/${formData.companyInfo}`),
        created_at: new Date()
      };

      const projectRef = doc(db, `projects/${nextId}`);
      await setDoc(projectRef, projectData);

      // Add district project reference
      if (formData.projectInfo.city && formData.projectInfo.district) {
        const districtProjectRef = doc(db, 
          `cities/${formData.projectInfo.city}/districts/${formData.projectInfo.district}/projects/${nextId}`);
        await setDoc(districtProjectRef, { exist: true });
      }

      // Add project reference to the company's projects subcollection
      if (formData.companyInfo) {
        const companyProjectRef = doc(db, `companies/${formData.companyInfo}/projects/${nextId}`);
        await setDoc(companyProjectRef, { exist: true });
      }

      // Add location details
      const locationDetailsRef = collection(db, `projects/${nextId}/location_details`);
      
      // Add locations document
      const locationsDoc = {
        google_maps_link: formData.locationInfo.mapsUrl,
        address: formData.locationInfo.address
      };
      await setDoc(doc(locationDetailsRef, "locations"), locationsDoc);

      // Add nearby locations
      const nearbyLocationsDoc = {
        park: {
          distance: formData.locationInfo.surroundings.park.distance,
          name: formData.locationInfo.surroundings.park.name
        },
        shopping_center: {
          distance: formData.locationInfo.surroundings.mall.distance,
          name: formData.locationInfo.surroundings.mall.name
        },
        metro_station: {
          distance: formData.locationInfo.surroundings.metro.distance,
          name: formData.locationInfo.surroundings.metro.name
        },
        bus_stop: {
          distance: formData.locationInfo.surroundings.bus.distance,
          name: formData.locationInfo.surroundings.bus.name
        }
      };
      await setDoc(doc(locationDetailsRef, "nearby_locations"), nearbyLocationsDoc);

      // Add nearby institutions
      const nearbyInstitutionsDoc = {
        school: {
          distance: formData.locationInfo.institutions.school.distance,
          name: formData.locationInfo.institutions.school.name
        },
        hospital: {
          distance: formData.locationInfo.institutions.hospital.distance,
          name: formData.locationInfo.institutions.hospital.name
        },
        municipality: {
          distance: formData.locationInfo.institutions.municipality.distance,
          name: formData.locationInfo.institutions.municipality.name
        },
        post_office: {
          distance: formData.locationInfo.institutions.postOffice.distance,
          name: formData.locationInfo.institutions.postOffice.name
        }
      };
      await setDoc(doc(locationDetailsRef, "nearby_institutions"), nearbyInstitutionsDoc);

      // Add apartment types
      if (formData.floorPlans.units && formData.floorPlans.units.length > 0) {
        const apartmentTypesRef = collection(db, `projects/${nextId}/apartment_types`);
        
        for (const unit of formData.floorPlans.units) {
          let imageUrl = "";
          if (unit.image) {
            const imageRef = ref(storage, `projects/${nextId}/apartment_types/${unit.type}/plan.jpg`);
            await uploadBytes(imageRef, unit.image);
            imageUrl = await getDownloadURL(imageRef);
          }

          const apartmentData = {
            net_area: unit.netArea,
            gross_area: unit.grossArea,
            facade: unit.orientation,
            balcony: unit.hasBalcony === "Var",
            image_url: imageUrl
          };

          await setDoc(doc(apartmentTypesRef, unit.type), apartmentData);
        }
      }

      // Add building features
      const buildingFeaturesRef = collection(db, `projects/${nextId}/building_features`);
      const buildingFeaturesDoc = {};
      buildingFeaturesList.forEach(feature => {
        buildingFeaturesDoc[feature] = formData.buildingFeatures[feature] || false;
      });
      await setDoc(doc(buildingFeaturesRef, "features"), buildingFeaturesDoc);

      // Add outside features
      const outsideFeaturesRef = collection(db, `projects/${nextId}/outside_features`);
      const outsideFeaturesDoc = {};
      outsideFeaturesList.forEach(feature => {
        outsideFeaturesDoc[feature] = formData.outsideFeatures[feature] || false;
      });
      await setDoc(doc(outsideFeaturesRef, "features"), outsideFeaturesDoc);

      // Add environment features
      const environmentFeaturesRef = collection(db, `projects/${nextId}/environment_features`);
      const environmentFeaturesDoc = {};
      environmentFeaturesList.forEach(feature => {
        environmentFeaturesDoc[feature] = formData.environmentFeatures[feature] || false;
      });
      await setDoc(doc(environmentFeaturesRef, "features"), environmentFeaturesDoc);

      alert("Proje başarıyla kaydedildi!");
      window.location.href = "/company_projects";
    } catch (error) {
      console.error("Error saving project:", error);
      alert("Proje kaydedilirken bir hata oluştu: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.header}>
        <h1 style={styles.mainTitle}>Yeni Proje Ekle</h1>
        <p style={styles.subtitle}>Proje bilgilerini aşağıdaki formu doldurarak ekleyin</p>
        {currentCompanyName && (
          <div style={styles.companyBadge}>
            <span style={styles.companyBadgeIcon}>🏢</span>
            <span style={styles.companyBadgeText}>{currentCompanyName}</span>
          </div>
        )}
      </div>
      
      <form onSubmit={handleSubmit} style={styles.formContainer}>
        {/* Proje Bilgileri Bölümü */}
        <ProjectInfo 
          onChange={handleProjectInfoChange} 
          cities={cities} 
          districts={districts} 
          fetchDistricts={fetchDistricts}
          loadingCities={loadingCities}
          loadingDistricts={loadingDistricts}
        />

        {/* Konum Bilgileri Bölümü */}
        <LocationInfo onChange={handleLocationInfoChange} />

        {/* Daire Planları Bölümü */}
        <FloorPlans onChange={handleFloorPlansChange} />

        {/* Şirket Bilgisi Bölümü */}
        <CompanyInfo 
          onChange={handleCompanyInfoChange} 
          companies={companies} 
          loadingCompanies={loadingCompanies}
          currentCompany={currentCompany}
          currentCompanyName={currentCompanyName}
        />

        {/* Özellikler Bölümü */}
        <div style={featuresStyles.container}>
          <div style={featuresStyles.header}>
            <h2 style={featuresStyles.title}>⭐ Proje Özellikleri</h2>
            <p style={featuresStyles.subtitle}>Projeye ait tüm özellikleri işaretleyin</p>
          </div>
          
          <BuildingFeatures 
            featuresList={buildingFeaturesList}
            onChange={handleBuildingFeaturesChange}
          />
          
          <OutsideFeatures 
            featuresList={outsideFeaturesList}
            onChange={handleOutsideFeaturesChange}
          />
          
          <EnvironmentFeatures 
            featuresList={environmentFeaturesList}
            onChange={handleEnvironmentFeaturesChange}
          />
        </div>

        {/* Gönder Butonu */}
        <div style={styles.buttonContainer}>
          <button 
            type="submit" 
            style={styles.submitButton}
            disabled={loading}
          >
            {loading ? (
              <>
                <div style={styles.spinner}></div>
                Kaydediliyor...
              </>
            ) : (
              "✅ Projeyi Kaydet"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

// ProjectInfo Component
const ProjectInfo = ({ onChange, cities, districts, fetchDistricts, loadingCities, loadingDistricts }) => {
  const [data, setData] = useState({
    projectName: "",
    price: "",
    city: "",
    district: "",
    deliveryDate: "",
    totalUnits: "",
    area: "",
    projectStatus: "",
    description: "",
    brochure: null,
    images: [],
  });

  useEffect(() => {
    onChange(data);
  }, [data, onChange]);

  const handleCityChange = async (e) => {
    const cityId = e.target.value;
    setData(prev => ({ ...prev, city: cityId, district: "" }));
    
    if (cityId) {
      await fetchDistricts(cityId);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setData(prev => ({ ...prev, images: files }));
  };

  const removeImage = (index) => {
    setData(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  return (
    <div style={projectInfoStyles.container}>
      <div style={projectInfoStyles.header}>
        <div style={projectInfoStyles.iconTitle}>
          <span style={projectInfoStyles.icon}>🏢</span>
          <div>
            <h2 style={projectInfoStyles.title}>Proje Bilgileri</h2>
            <p style={projectInfoStyles.subtitle}>Temel proje bilgilerini girin</p>
          </div>
        </div>
      </div>

      <div style={projectInfoStyles.content}>
        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Proje Adı *</label>
          <input
            type="text"
            value={data.projectName}
            onChange={(e) => setData({ ...data, projectName: e.target.value })}
            style={projectInfoStyles.input}
            placeholder="Proje adı girin"
            required
          />
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Fiyat *</label>
          <input
            type="text"
            value={data.price}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
              setData({ ...data, price: onlyNumbers });
            }}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowRight" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            inputMode="numeric"
            style={projectInfoStyles.input}
            placeholder="Örn: 2500000"
            required
          />
        </div>


        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>İl *</label>
          <div style={projectInfoStyles.selectWrapper}>
            <select
              value={data.city}
              onChange={handleCityChange}
              style={projectInfoStyles.select}
              required
            >
              <option value="">İl seçin</option>
              {loadingCities ? (
                <option>Yükleniyor...</option>
              ) : (
                cities.map(city => (
                  <option key={city} value={city}>{city}</option>
                ))
              )}
            </select>
            <div style={projectInfoStyles.selectArrow}>▼</div>
          </div>
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>İlçe *</label>
          <div style={projectInfoStyles.selectWrapper}>
            <select
              value={data.district}
              onChange={(e) => setData({ ...data, district: e.target.value })}
              style={{
                ...projectInfoStyles.select,
                ...(!data.city && projectInfoStyles.selectDisabled)
              }}
              required
              disabled={!data.city}
            >
              <option value="">{data.city ? 'İlçe seçin' : 'Önce şehir seçin'}</option>
              {loadingDistricts ? (
                <option>İlçeler yükleniyor...</option>
              ) : (
                districts.map(district => (
                  <option key={district} value={district}>{district}</option>
                ))
              )}
            </select>
            <div style={projectInfoStyles.selectArrow}>▼</div>
          </div>
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Teslim Tarihi *</label>
          <input
            type="text"
            value={data.deliveryDate}
            onChange={(e) => setData({ ...data, deliveryDate: e.target.value })}
            style={projectInfoStyles.input}
            placeholder="Örn: Aralık 2025"
            required
          />
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Toplam Konut Sayısı *</label>
          <input
            type="number"
            value={data.totalUnits}
            onChange={(e) => setData({ ...data, totalUnits: e.target.value })}
            style={projectInfoStyles.input}
            placeholder="Örn: 120"
            required
          />
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Proje Alanı *</label>
          <input
            type="text"
            value={data.area}
            onChange={(e) => setData({ ...data, area: e.target.value })}
            style={projectInfoStyles.input}
            placeholder="Örn: 10.000 m²"
            required
          />
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Proje Açıklaması *</label>
          <textarea
            value={data.description}
            onChange={(e) => setData({ ...data, description: e.target.value })}
            style={projectInfoStyles.textarea}
            placeholder="Proje hakkında detaylı bilgi..."
            rows="4"
            required
          />
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Broşür Yükle (PDF)</label>
          <div style={projectInfoStyles.fileInputContainer}>
            <input
              type="file"
              accept=".pdf"
              onChange={(e) => setData({ ...data, brochure: e.target.files[0] })}
              style={projectInfoStyles.fileInput}
              id="brochure-upload"
            />
            <label htmlFor="brochure-upload" style={projectInfoStyles.fileInputLabel}>
              <span style={projectInfoStyles.fileInputIcon}>📄</span>
              {data.brochure ? data.brochure.name : "PDF Dosyası Seçin"}
            </label>
          </div>
        </div>

        <div style={projectInfoStyles.fieldGroup}>
          <label style={projectInfoStyles.label}>Görseller (.png, .jpg, .jpeg)</label>
          <div style={projectInfoStyles.fileInputContainer}>
            <input
              type="file"
              multiple
              accept=".png,.jpg,.jpeg"
              onChange={handleImageChange}
              style={projectInfoStyles.fileInput}
              id="image-upload"
            />
            <label htmlFor="image-upload" style={projectInfoStyles.fileInputLabel}>
              <span style={projectInfoStyles.fileInputIcon}>🖼️</span>
              Görsel Seçin
            </label>
          </div>
          {data.images.length > 0 && (
            <div style={projectInfoStyles.imagePreviewContainer}>
              <p style={projectInfoStyles.imagePreviewTitle}>
                Seçilen Görseller ({data.images.length})
              </p>
              <div style={projectInfoStyles.imageGrid}>
                {data.images.map((img, index) => (
                  <div key={index} style={projectInfoStyles.imageBox}>
                    <img 
                      src={URL.createObjectURL(img)} 
                      alt={`preview-${index}`} 
                      style={projectInfoStyles.image} 
                    />
                    <button 
                      type="button"
                      onClick={() => removeImage(index)}
                      style={projectInfoStyles.removeImageButton}
                    >
                      ×
                    </button>
                    <span style={projectInfoStyles.imageName}>{img.name}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// LocationInfo Component
const LocationInfo = ({ onChange }) => {
  const [locationData, setLocationData] = useState({
    mapsUrl: "",
    address: "",
    surroundings: {
      park: { distance: "", name: "" },
      mall: { distance: "", name: "" },
      metro: { distance: "", name: "" },
      bus: { distance: "", name: "" },
    },
    institutions: {
      school: { distance: "", name: "" },
      hospital: { distance: "", name: "" },
      municipality: { distance: "", name: "" },
      postOffice: { distance: "", name: "" },
    },
  });

  useEffect(() => {
    onChange(locationData);
  }, [locationData, onChange]);

  const handleInputChange = (section, key, field, value) => {
    setLocationData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: {
          ...prev[section][key],
          [field]: value,
        },
      },
    }));
  };

  const handleTopLevelChange = (field, value) => {
    setLocationData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const renderCard = (section, key, title, icon) => (
    <div style={locationInfoStyles.card}>
      <div style={locationInfoStyles.cardHeader}>
        <span style={locationInfoStyles.cardIcon}>{icon}</span>
        <h4 style={locationInfoStyles.cardTitle}>{title}</h4>
      </div>
      <div style={locationInfoStyles.cardContent}>
        <div style={locationInfoStyles.inputWrapper}>
          <label style={locationInfoStyles.smallLabel}>Mesafe (m)</label>
          <input
            type="number"
            placeholder="Mesafe"
            value={locationData[section][key].distance}
            onChange={(e) =>
              handleInputChange(section, key, "distance", e.target.value)
            }
            style={locationInfoStyles.input}
          />
        </div>
        <div style={locationInfoStyles.inputWrapper}>
          <label style={locationInfoStyles.smallLabel}>İsim</label>
          <input
            type="text"
            placeholder="İsim"
            value={locationData[section][key].name}
            onChange={(e) =>
              handleInputChange(section, key, "name", e.target.value)
            }
            style={locationInfoStyles.input}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div style={locationInfoStyles.container}>
      <div style={locationInfoStyles.header}>
        <div style={locationInfoStyles.iconTitle}>
          <span style={locationInfoStyles.icon}>📍</span>
          <div>
            <h2 style={locationInfoStyles.title}>Konum Bilgileri</h2>
            <p style={locationInfoStyles.subtitle}>Projenin konum ve çevre bilgilerini girin</p>
          </div>
        </div>
      </div>

      <div style={locationInfoStyles.content}>
        <div style={locationInfoStyles.fieldGroup}>
          <label style={locationInfoStyles.label}>Google Maps URL *</label>
          <input
            type="url"
            placeholder="https://maps.google.com/..."
            value={locationData.mapsUrl}
            onChange={(e) => handleTopLevelChange("mapsUrl", e.target.value)}
            style={locationInfoStyles.input}
            required
          />
        </div>

        <div style={locationInfoStyles.fieldGroup}>
          <label style={locationInfoStyles.label}>Açık Adres *</label>
          <textarea
            rows={3}
            placeholder="Projenin açık adresini girin"
            value={locationData.address}
            onChange={(e) => handleTopLevelChange("address", e.target.value)}
            style={locationInfoStyles.textarea}
            required
          />
        </div>

        <div style={locationInfoStyles.section}>
          <h3 style={locationInfoStyles.sectionTitle}>🏙️ Yakın Çevre</h3>
          <div style={locationInfoStyles.cardsContainer}>
            {renderCard("surroundings", "park", "Park Alanı", "🌳")}
            {renderCard("surroundings", "mall", "AVM", "🛍️")}
            {renderCard("surroundings", "metro", "Metro / Tramvay", "🚇")}
            {renderCard("surroundings", "bus", "Otobüs Durağı", "🚌")}
          </div>
        </div>

        <div style={locationInfoStyles.section}>
          <h3 style={locationInfoStyles.sectionTitle}>🏫 Kurum ve Kuruluşlar</h3>
          <div style={locationInfoStyles.cardsContainer}>
            {renderCard("institutions", "school", "Okul", "🎓")}
            {renderCard("institutions", "hospital", "Hastane", "🏥")}
            {renderCard("institutions", "municipality", "Belediye", "🏛️")}
            {renderCard("institutions", "postOffice", "Postane", "📮")}
          </div>
        </div>
      </div>
    </div>
  );
};

// FloorPlans Component
const FloorPlans = ({ onChange }) => {
  const [description, setDescription] = useState("");
  const [units, setUnits] = useState([]);

  useEffect(() => {
    onChange({ description, units });
  }, [description, units, onChange]);

  const addUnit = () => {
    setUnits([
      ...units,
      {
        type: "",
        image: null,
        netArea: "",
        grossArea: "",
        orientation: "",
        hasBalcony: "",
      },
    ]);
  };

  const updateUnit = (index, updated) => {
    const updatedUnits = [...units];
    updatedUnits[index] = { ...updatedUnits[index], ...updated };
    setUnits(updatedUnits);
  };

  const removeUnit = (index) => {
    const updatedUnits = units.filter((_, i) => i !== index);
    setUnits(updatedUnits);
  };

  const orientationOptions = ["Doğu", "Batı", "Güney", "Kuzey", "Belirtilmedi"];
  const apartmentTypes = [
    "1+0", "1+1", "2+1", "3+1", "4+1", "4+2", "5+1", "5+2",
    "6+1", "6+2", "7+1", "7+2", "8+1", "8+2", "9+1", "9+2"
  ];

  return (
    <div style={floorPlansStyles.container}>
      <div style={floorPlansStyles.header}>
        <div style={floorPlansStyles.iconTitle}>
          <span style={floorPlansStyles.icon}>📐</span>
          <div>
            <h2 style={floorPlansStyles.title}>Daire Planları</h2>
            <p style={floorPlansStyles.subtitle}>Mimari açıklama ve daire tiplerini ekleyin</p>
          </div>
        </div>
      </div>

      <div style={floorPlansStyles.content}>
        <div style={floorPlansStyles.fieldGroup}>
          <label style={floorPlansStyles.label}>Mimari Açıklama *</label>
          <textarea
            placeholder="Mimari açıklamayı buraya yazın..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={floorPlansStyles.textarea}
            rows="4"
            required
          />
        </div>

        <div style={floorPlansStyles.section}>
          <div style={floorPlansStyles.sectionHeader}>
            <h3 style={floorPlansStyles.sectionTitle}>Daire Tipleri</h3>
            <button 
              onClick={addUnit} 
              style={floorPlansStyles.addButton}
              type="button"
            >
              + Yeni Daire Tipi Ekle
            </button>
          </div>

          <div style={floorPlansStyles.unitsContainer}>
            {units.map((unit, index) => (
              <div key={index} style={floorPlansStyles.unitCard}>
                <div style={floorPlansStyles.unitHeader}>
                  <h4 style={floorPlansStyles.unitTitle}>
                    Daire Tipi {index + 1}
                  </h4>
                  <button
                    onClick={() => removeUnit(index)}
                    style={floorPlansStyles.deleteButton}
                    type="button"
                  >
                    🗑️ Sil
                  </button>
                </div>

                <div style={floorPlansStyles.unitContent}>
                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Daire Tipi *</label>
                    <select
                      value={unit.type}
                      onChange={(e) => updateUnit(index, { type: e.target.value })}
                      style={floorPlansStyles.select}
                      required
                    >
                      <option value="">Tip seçin</option>
                      {apartmentTypes.map((type) => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Net Alan (m²) *</label>
                    <input
                      type="number"
                      placeholder="Net Alan"
                      value={unit.netArea}
                      onChange={(e) => updateUnit(index, { netArea: e.target.value })}
                      style={floorPlansStyles.input}
                      required
                    />
                  </div>

                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Brüt Alan (m²) *</label>
                    <input
                      type="number"
                      placeholder="Brüt Alan"
                      value={unit.grossArea}
                      onChange={(e) => updateUnit(index, { grossArea: e.target.value })}
                      style={floorPlansStyles.input}
                      required
                    />
                  </div>

                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Cephe *</label>
                    <select
                      value={unit.orientation}
                      onChange={(e) => updateUnit(index, { orientation: e.target.value })}
                      style={floorPlansStyles.select}
                      required
                    >
                      <option value="">Cephe seçin</option>
                      {orientationOptions.map((dir) => (
                        <option key={dir} value={dir}>{dir}</option>
                      ))}
                    </select>
                  </div>

                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Balkon *</label>
                    <select
                      value={unit.hasBalcony}
                      onChange={(e) => updateUnit(index, { hasBalcony: e.target.value })}
                      style={floorPlansStyles.select}
                      required
                    >
                      <option value="">Seçin</option>
                      <option value="Var">Var</option>
                      <option value="Yok">Yok</option>
                    </select>
                  </div>

                  <div style={floorPlansStyles.fieldGroup}>
                    <label style={floorPlansStyles.smallLabel}>Kat Planı *</label>
                    <div style={floorPlansStyles.fileInputContainer}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          updateUnit(index, { image: e.target.files[0] || null })
                        }
                        style={floorPlansStyles.fileInput}
                        id={`unit-image-${index}`}
                        required
                      />
                      <label htmlFor={`unit-image-${index}`} style={floorPlansStyles.fileInputLabel}>
                        <span style={floorPlansStyles.fileInputIcon}>🖼️</span>
                        {unit.image ? unit.image.name : "Görsel Seçin"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {units.length === 0 && (
            <div style={floorPlansStyles.emptyState}>
              <div style={floorPlansStyles.emptyIcon}>📐</div>
              <p style={floorPlansStyles.emptyText}>
                Henüz daire tipi eklenmemiş. İlk daire tipini eklemek için butona tıklayın.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// CompanyInfo Component
const CompanyInfo = ({ onChange, companies, loadingCompanies, currentCompany, currentCompanyName }) => {
  useEffect(() => {
    if (currentCompany) {
      onChange(currentCompany);
    }
  }, [currentCompany, onChange]);

  return (
    <div style={companyInfoStyles.container}>
      <div style={companyInfoStyles.header}>
        <div style={companyInfoStyles.iconTitle}>
          <span style={companyInfoStyles.icon}>🏢</span>
          <div>
            <h2 style={companyInfoStyles.title}>Şirket Bilgisi</h2>
            <p style={companyInfoStyles.subtitle}>Projenin bağlı olacağı şirketi seçin</p>
          </div>
        </div>
      </div>
      
      <div style={companyInfoStyles.content}>
        {currentCompany ? (
          <div style={companyInfoStyles.currentCompany}>
            <div style={companyInfoStyles.companyCard}>
              <div style={companyInfoStyles.companyIcon}>🏢</div>
              <div style={companyInfoStyles.companyInfo}>
                <h3 style={companyInfoStyles.companyName}>{currentCompanyName || currentCompany}</h3>
                <p style={companyInfoStyles.companyText}>
                  Proje bu şirket adına kaydedilecektir. Değiştirmek için aşağıdaki listeden farklı bir şirket seçebilirsiniz.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div style={companyInfoStyles.fieldGroup}>
            <label style={companyInfoStyles.label}>Şirket Seçin *</label>
            <div style={companyInfoStyles.selectWrapper}>
              <select
                value={currentCompany}
                onChange={(e) => onChange(e.target.value)}
                style={companyInfoStyles.select}
                required
              >
                <option value="">Bir şirket seçin</option>
                {loadingCompanies ? (
                  <option>Yükleniyor...</option>
                ) : (
                  companies.map((company) => (
                    <option key={company} value={company}>
                      {company}
                    </option>
                  ))
                )}
              </select>
              <div style={companyInfoStyles.selectArrow}>▼</div>
            </div>
          </div>
        )}

        {!currentCompany && (
          <div style={companyInfoStyles.infoBox}>
            <div style={companyInfoStyles.infoIcon}>ℹ️</div>
            <div style={companyInfoStyles.infoContent}>
              <h4 style={companyInfoStyles.infoTitle}>Şirket Seçimi</h4>
              <p style={companyInfoStyles.infoText}>
                Projenin bağlı olacağı şirketi listeden seçin. Eğer şirketiniz listede yoksa, önce şirket bilgilerini eklemeniz gerekmektedir.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// BuildingFeatures Component
const BuildingFeatures = ({ featuresList, onChange }) => {
  const [selectedFeatures, setSelectedFeatures] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const handleFeatureChange = (feature) => {
    setSelectedFeatures(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  useEffect(() => {
    onChange(selectedFeatures);
  }, [selectedFeatures, onChange]);

  const filteredFeatures = featuresList.filter(feature =>
    feature.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={featuresStyles.featureSection}>
      <div style={featuresStyles.sectionHeader}>
        <h3 style={featuresStyles.subTitle}>🏢 Bina Özellikleri</h3>
        <div style={featuresStyles.searchContainer}>
          <input
            type="text"
            placeholder="Özellik ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={featuresStyles.searchInput}
          />
          <span style={featuresStyles.searchIcon}>🔍</span>
        </div>
      </div>
      <div style={featuresStyles.featuresContainer}>
        {filteredFeatures.map((feature, index) => (
          <div key={index} style={featuresStyles.featureItem}>
            <input
              type="checkbox"
              id={`building-${index}`}
              checked={selectedFeatures[feature] || false}
              onChange={() => handleFeatureChange(feature)}
              style={featuresStyles.checkbox}
            />
            <label htmlFor={`building-${index}`} style={featuresStyles.featureLabel}>
              <span style={featuresStyles.checkboxCustom}></span>
              {feature}
            </label>
          </div>
        ))}
      </div>
      {filteredFeatures.length === 0 && (
        <div style={featuresStyles.noResults}>
          Arama kriterlerine uygun özellik bulunamadı.
        </div>
      )}
    </div>
  );
};

// OutsideFeatures Component
const OutsideFeatures = ({ featuresList, onChange }) => {
  const [selectedFeatures, setSelectedFeatures] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const handleFeatureChange = (feature) => {
    setSelectedFeatures(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  useEffect(() => {
    onChange(selectedFeatures);
  }, [selectedFeatures, onChange]);

  const filteredFeatures = featuresList.filter(feature =>
    feature.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={featuresStyles.featureSection}>
      <div style={featuresStyles.sectionHeader}>
        <h3 style={featuresStyles.subTitle}>🌳 Dış Özellikler</h3>
        <div style={featuresStyles.searchContainer}>
          <input
            type="text"
            placeholder="Özellik ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={featuresStyles.searchInput}
          />
          <span style={featuresStyles.searchIcon}>🔍</span>
        </div>
      </div>
      <div style={featuresStyles.featuresContainer}>
        {filteredFeatures.map((feature, index) => (
          <div key={index} style={featuresStyles.featureItem}>
            <input
              type="checkbox"
              id={`outside-${index}`}
              checked={selectedFeatures[feature] || false}
              onChange={() => handleFeatureChange(feature)}
              style={featuresStyles.checkbox}
            />
            <label htmlFor={`outside-${index}`} style={featuresStyles.featureLabel}>
              <span style={featuresStyles.checkboxCustom}></span>
              {feature}
            </label>
          </div>
        ))}
      </div>
      {filteredFeatures.length === 0 && (
        <div style={featuresStyles.noResults}>
          Arama kriterlerine uygun özellik bulunamadı.
        </div>
      )}
    </div>
  );
};

// EnvironmentFeatures Component
const EnvironmentFeatures = ({ featuresList, onChange }) => {
  const [selectedFeatures, setSelectedFeatures] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const handleFeatureChange = (feature) => {
    setSelectedFeatures(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  useEffect(() => {
    onChange(selectedFeatures);
  }, [selectedFeatures, onChange]);

  const filteredFeatures = featuresList.filter(feature =>
    feature.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={featuresStyles.featureSection}>
      <div style={featuresStyles.sectionHeader}>
        <h3 style={featuresStyles.subTitle}>🏙️ Çevre Özellikleri</h3>
        <div style={featuresStyles.searchContainer}>
          <input
            type="text"
            placeholder="Özellik ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={featuresStyles.searchInput}
          />
          <span style={featuresStyles.searchIcon}>🔍</span>
        </div>
      </div>
      <div style={featuresStyles.featuresContainer}>
        {filteredFeatures.map((feature, index) => (
          <div key={index} style={featuresStyles.featureItem}>
            <input
              type="checkbox"
              id={`environment-${index}`}
              checked={selectedFeatures[feature] || false}
              onChange={() => handleFeatureChange(feature)}
              style={featuresStyles.checkbox}
            />
            <label htmlFor={`environment-${index}`} style={featuresStyles.featureLabel}>
              <span style={featuresStyles.checkboxCustom}></span>
              {feature}
            </label>
          </div>
        ))}
      </div>
      {filteredFeatures.length === 0 && (
        <div style={featuresStyles.noResults}>
          Arama kriterlerine uygun özellik bulunamadı.
        </div>
      )}
    </div>
  );
};

// Main Styles
const styles = {
  mainContainer: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
    padding: "20px 0",
    position: "relative",
  },
  mainTitle: {
    fontSize: "2rem",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "1rem",
    color: "#64748b",
    fontWeight: "400",
    marginBottom: "15px",
  },
  companyBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    backgroundColor: "#f0f9ff",
    border: "1px solid #0ea5e9",
    borderRadius: "20px",
    marginTop: "10px",
  },
  companyBadgeIcon: {
    fontSize: "16px",
  },
  companyBadgeText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#0369a1",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "40px",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  submitButton: {
    padding: "16px 40px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
    minWidth: "200px",
    justifyContent: "center",
  },
  spinner: {
    width: "20px",
    height: "20px",
    border: "2px solid transparent",
    borderTop: "2px solid white",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// ProjectInfo Styles
const projectInfoStyles = {
  container: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f8fafc",
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
  },
  iconTitle: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  icon: {
    fontSize: "24px",
    marginTop: "4px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
  content: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: "600",
    color: "#374151",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    maxWidth: "400px",
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
    backgroundColor: '#fff',
  },
  selectWrapper: {
    position: "relative",
    maxWidth: "400px",
  },
  select: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
    backgroundColor: '#fff',
    appearance: "none",
  },
  selectArrow: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
    pointerEvents: "none",
  },
  selectDisabled: {
    backgroundColor: "#f9fafb",
    color: "#9ca3af",
    cursor: "not-allowed",
  },
  textarea: {
    width: "100%",
    maxWidth: "400px",
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    resize: "none",
    minHeight: "100px",
    outline: "none",
    color: '#374151',
    transition: "all 0.3s ease",
  },
  rangeContainer: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    maxWidth: "400px",
  },
  range: {
    flex: 1,
    height: "6px",
    borderRadius: "3px",
    background: "#e5e7eb",
    outline: "none",
  },
  rangeValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    minWidth: "40px",
  },
  fileInputContainer: {
    position: "relative",
    maxWidth: "400px",
  },
  fileInput: {
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  fileInputLabel: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 16px",
    backgroundColor: "#f8fafc",
    border: "2px dashed #d1d5db",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "14px",
    color: "#6b7280",
  },
  fileInputIcon: {
    fontSize: "16px",
  },
  imagePreviewContainer: {
    marginTop: "15px",
  },
  imagePreviewTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "10px",
  },
  imageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
    gap: "10px",
  },
  imageBox: {
    position: "relative",
    width: "80px",
    height: "80px",
    borderRadius: "6px",
    overflow: "hidden",
    border: "2px solid #e5e7eb",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  removeImageButton: {
    position: "absolute",
    top: "2px",
    right: "2px",
    width: "18px",
    height: "18px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageName: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    backgroundColor: "rgba(0,0,0,0.7)",
    color: "white",
    fontSize: "9px",
    padding: "2px 4px",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

// LocationInfo Styles
const locationInfoStyles = {
  container: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f8fafc",
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
  },
  iconTitle: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  icon: {
    fontSize: "24px",
    marginTop: "4px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
  content: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
  },
  smallLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#6b7280",
  },
  input: {
    width: "100%",
    maxWidth: "400px",
    padding: "10px 12px",
    fontSize: "14px",
    border: "2px solid #e5e7eb",
    borderRadius: "6px",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
  },
  textarea: {
    width: "100%",
    maxWidth: "400px",
    padding: "10px 12px",
    fontSize: "14px",
    border: "2px solid #e5e7eb",
    borderRadius: "6px",
    outline: "none",
    resize: "vertical",
    minHeight: "80px",
    transition: "all 0.3s ease",
    color: '#374151',
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1e293b",
    margin: "0",
    paddingBottom: "8px",
    borderBottom: "1px solid #f1f5f9",
  },
  cardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  card: {
    backgroundColor: "#f8fafc",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    maxWidth: "400px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "12px",
  },
  cardIcon: {
    fontSize: "18px",
  },
  cardTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1e293b",
    margin: 0,
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
};

// FloorPlans Styles
const floorPlansStyles = {
  container: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f8fafc",
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
  },
  iconTitle: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  icon: {
    fontSize: "24px",
    marginTop: "4px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
  content: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontWeight: "600",
    color: "#374151",
    fontSize: "14px",
  },
  smallLabel: {
    fontWeight: "500",
    color: "#6b7280",
    fontSize: "12px",
  },
  textarea: {
    width: "100%",
    maxWidth: "400px",
    minHeight: "100px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    padding: "12px 16px",
    fontSize: "14px",
    resize: "vertical",
    color: '#374151',
    transition: "all 0.3s ease",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1e293b",
    margin: 0,
  },
  addButton: {
    padding: "8px 16px",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  unitsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  unitCard: {
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "16px",
    backgroundColor: "#f8fafc",
  },
  unitHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    flexWrap: "wrap",
    gap: "10px",
  },
  unitTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1e293b",
    margin: 0,
  },
  unitContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  input: {
    padding: "10px 12px",
    borderRadius: "6px",
    border: "2px solid #e5e7eb",
    fontSize: "14px",
    color: '#374151',
    transition: "all 0.3s ease",
    maxWidth: "400px",
  },
  select: {
    padding: "10px 12px",
    borderRadius: "6px",
    border: "2px solid #e5e7eb",
    fontSize: "14px",
    color: '#374151',
    backgroundColor: '#fff',
    transition: "all 0.3s ease",
    maxWidth: "400px",
  },
  fileInputContainer: {
    position: "relative",
    maxWidth: "400px",
  },
  fileInput: {
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  fileInputLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 12px",
    backgroundColor: "#fff",
    border: "1px dashed #d1d5db",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "12px",
    color: "#6b7280",
  },
  fileInputIcon: {
    fontSize: "14px",
  },
  deleteButton: {
    padding: "6px 12px",
    backgroundColor: "#ef4444",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px 20px",
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
    border: "1px dashed #d1d5db",
  },
  emptyIcon: {
    fontSize: "32px",
    marginBottom: "12px",
  },
  emptyText: {
    fontSize: "14px",
    color: "#6b7280",
    margin: "0 auto",
    maxWidth: "300px",
  },
};

// CompanyInfo Styles
const companyInfoStyles = {
  container: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f8fafc",
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
  },
  iconTitle: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  icon: {
    fontSize: "24px",
    marginTop: "4px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
  content: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: "600",
    color: "#374151",
    fontSize: "14px",
  },
  selectWrapper: {
    position: "relative",
    maxWidth: "400px",
  },
  select: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
    backgroundColor: '#fff',
    appearance: "none",
  },
  selectArrow: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
    pointerEvents: "none",
  },
  currentCompany: {
    marginBottom: "10px",
  },
  companyCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    padding: "16px",
    backgroundColor: "#f0f9ff",
    border: "1px solid #0ea5e9",
    borderRadius: "8px",
    maxWidth: "400px",
    marginBottom: "20px",
  },
  companyIcon: {
    fontSize: "24px",
    marginTop: "2px",
  },
  companyInfo: {
    flex: 1,
  },
  companyName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#0369a1",
    marginBottom: "6px",
  },
  companyText: {
    fontSize: "13px",
    color: "#64748b",
    lineHeight: "1.4",
  },
  infoBox: {
    display: "flex",
    gap: "12px",
    padding: "16px",
    backgroundColor: "#fef3c7",
    border: "1px solid #f59e0b",
    borderRadius: "8px",
    maxWidth: "400px",
  },
  infoIcon: {
    fontSize: "18px",
    marginTop: "2px",
  },
  infoContent: {
    flex: 1,
  },
  infoTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#92400e",
    marginBottom: "6px",
  },
  infoText: {
    fontSize: "13px",
    color: "#92400e",
    lineHeight: "1.4",
  },
};

// Features Styles
const featuresStyles = {
  container: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#f8fafc",
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
  featureSection: {
    padding: "24px",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  subTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1e293b",
    margin: 0,
  },
  searchContainer: {
    position: "relative",
    maxWidth: "400px",
  },
  searchInput: {
    width: "100%",
    padding: "8px 35px 8px 12px",
    fontSize: "14px",
    border: "2px solid #e5e7eb",
    borderRadius: "6px",
    outline: "none",
    transition: "all 0.3s ease",
  },
  searchIcon: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
  },
  featuresContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    maxHeight: "300px",
    overflowY: "auto",
    padding: "5px",
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 12px",
    backgroundColor: "#f8fafc",
    borderRadius: "6px",
    border: "1px solid #e2e8f0",
  },
  checkbox: {
    display: "none",
  },
  featureLabel: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    color: "#374151",
    cursor: "pointer",
    fontWeight: "500",
    width: "100%",
  },
  checkboxCustom: {
    width: "16px",
    height: "16px",
    border: "2px solid #d1d5db",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    flexShrink: 0,
  },
  noResults: {
    textAlign: "center",
    padding: "20px",
    color: "#6b7280",
    fontSize: "14px",
    fontStyle: "italic",
  },
};

// Add CSS animation for spinner
const spinnerStyle = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

input[type="checkbox"]:checked + label span:first-child {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

input[type="checkbox"]:checked + label span:first-child::after {
  content: "✓";
  color: white;
  font-size: 10px;
  font-weight: bold;
}

input[type="checkbox"]:checked + label {
  color: #1e293b;
  font-weight: 600;
}

input[type="range"] {
  -webkit-appearance: none;
  background: #e5e7eb;
  height: 6px;
  border-radius: 3px;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background: #3b82f6;
  border-radius: 50%;
  cursor: pointer;
}

input[type="range"]::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  border: none;
}

/* Focus states */
input:focus, select:focus, textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* Hover effects */
button:hover {
  transform: translateY(-1px);
}

/* Responsive design */
@media (max-width: 768px) {
  .mainContainer {
    padding: 10px;
  }
  
  .formContainer {
    gap: 20px;
  }
  
  .projectInfoStyles.content,
  .locationInfoStyles.content,
  .floorPlansStyles.content,
  .companyInfoStyles.content {
    padding: 16px;
  }
  
  .projectInfoStyles.header,
  .locationInfoStyles.header,
  .floorPlansStyles.header,
  .companyInfoStyles.header,
  .featuresStyles.header {
    padding: 16px;
  }
  
  .floorPlansStyles.sectionHeader {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .floorPlansStyles.addButton {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .mainTitle {
    font-size: 1.5rem;
  }
  
  .submitButton {
    width: 100%;
    padding: 14px 20px;
  }
  
  .projectInfoStyles.iconTitle,
  .locationInfoStyles.iconTitle,
  .floorPlansStyles.iconTitle,
  .companyInfoStyles.iconTitle {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  
  .projectInfoStyles.icon,
  .locationInfoStyles.icon,
  .floorPlansStyles.icon,
  .companyInfoStyles.icon {
    margin-top: 0;
  }
}
`;

// Add the styles to the document
const styleSheet = document.createElement("style");
styleSheet.innerText = spinnerStyle;
document.head.appendChild(styleSheet);

export default AddProjects;